<template>
<div class="micad_userDetails">
  <div class="micad_userDetails_name">{{name}}</div>
  <div class="micad_userDetails_role">{{role}}</div>
</div>
</template>

<script>
export default {
  name: 'User-detials',
  data() {
    return {
        name: "Johnathen Fletcher",
        role: "Role details to for the user to go here"
        }
    },
};
</script>
